export type Product = {
  name: string;
  tagline: string;
  description: string;
  status: string;
  asset: string;
  href?: string;
};

export const products: Product[] = [
  {
    "name": "Who Watches The Agents? Tee",
    "tagline": "WHO WATCHES THE AGENTS?",
    "description": "The cleanest first-gen statement: it asks the question before claiming the answer. Built for builders, reviewers, operators, and anyone watching automated systems move fast.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/who-watches-agents-tee.png?v=commerce1",
    "href": "/first-gen-who-watches-agents-tee.html"
  },
  {
    "name": "Quis Custodiet Tee",
    "tagline": "QUIS CUSTODIET?",
    "description": "The Latin-question tee. It keeps CUSTOS mysterious but grounded: before \u201cwe are the watchers,\u201d the line starts by asking who watches power.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/quis-custodiet-tee.png?v=commerce1",
    "href": "/first-gen-quis-custodiet-tee.html"
  },
  {
    "name": "Power Needs A Witness Tee",
    "tagline": "POWER NEEDS A WITNESS.",
    "description": "A direct public-facing first-gen tee. Less lore, more punch. It explains the brand without needing the customer to know the oath yet.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/power-needs-witness-tee.png?v=commerce1",
    "href": "/first-gen-power-needs-witness-tee.html"
  },
  {
    "name": "Guards Not Exempt Hoodie",
    "tagline": "THE GUARDS ARE NOT EXEMPT.",
    "description": "The first-gen hoodie for the accountability lane. This is the clearest bridge from ancient watcher language to modern agent oversight.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/guards-not-exempt-hoodie.png?v=commerce1",
    "href": "/first-gen-guards-not-exempt-hoodie.html"
  },
  {
    "name": "Trust Is Not A Control System Desk Mat",
    "tagline": "TRUST IS NOT A CONTROL SYSTEM.",
    "description": "A workstation product for the real CUSTOS audience. It speaks directly to systems thinking without jumping all the way to the oath line.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/trust-control-desk-mat.png?v=commerce1",
    "href": "/first-gen-trust-control-desk-mat.html"
  },
  {
    "name": "Guardrails Sticker / Patch Set",
    "tagline": "GUARDRAILS FOR THE GUARDIANS.",
    "description": "A small-product lane for the earliest CUSTOS symbols: shield, eye, tower, red signal, and the accountability phrase.",
    "status": "Drop 1 / First Gen",
    "asset": "/assets/first-gen-v1/png/guardrails-sticker-patch-set.png?v=commerce1",
    "href": "/first-gen-guardrails-sticker-patch-set.html"
  }
];
